import { render, staticRenderFns } from "./AttributeEditorDialog.vue?vue&type=template&id=4c335fe8"
import script from "./AttributeEditorDialog.vue?vue&type=script&lang=ts"
export * from "./AttributeEditorDialog.vue?vue&type=script&lang=ts"
import style0 from "./AttributeEditorDialog.vue?vue&type=style&index=0&id=4c335fe8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports